// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2bM5m","productName":"Table_productName__MxDte"};